import Create from '@mui/icons-material/Create';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CreateIcon(props: FixMe) {
  return <Create {...props} />;
}

export default CreateIcon;
